import { baseRoutes } from "helpers/baseRoutes";

const accessRoute = {
  SEARCHBYLOCATION: {
    path: `${baseRoutes.userBaseRoutes}search-location`,
  },
};

export default accessRoute;
